import { floatDiv } from '@/utils'
// eslint-disable-next-line no-unused-vars
import store from '@/store'
// 数字转"万" 过滤器
export const numberTextFormat = function (value) {
  if (value !== undefined && value !== null) {
    if (Number(value) < 10000) {
      let str = value.toString()
      return str
    } else {
      let str = Number((Number(value) / 10000).toFixed(2)).toString()
      return str + 'w'
    }
  } else {
    return ''
  }
}

/**
 * 时间过滤器
 * @date 2021-08-23
 * @param {any} 时间/时间戳
 * @param {any} 转换格式
 * @returns {any} 转换好的时间格式
 */
export const dateFormat = function (time, fmt) {
  if (!time) {
    return
  }
  fmt = fmt || 'yyyy-MM-dd hh:mm'
  let date = new Date(time)

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }

  let dt = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  }

  for (let key in dt) {
    if (new RegExp(`(${key})`).test(fmt)) {
      let str = dt[key] + ''
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length)
      )
    }
  }

  return fmt
}

/**
 * 查找字典项真实name值
 * @date 2021-08-23
 * @param {String} ConfigCode
 * @returns {String} ConfigName
 */
export const dictionaryGetName = function (value) {
  if (!value) return
  const dictionary = store.getters['system/getDictionary'] || []
  let text = dictionary[value] || value
  return text
}

export function money(val) {
  if (val == 0) return 0
  return floatDiv(val, 100)
}

export function moneyStr(money) {
  let str = floatDiv(money, 100) || 0
  if (str == 0) return 0
  str = str.toString()
  str.indexOf('.') == '-1'
    ? (str = str.slice(0))
    : (str = str.slice(0, str.indexOf('.') + 3))
  str = str.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
  return str
}

export function numStr(num, fixed = 0) {
  if (!num || num == 0) return 0
  return num.toFixed(fixed).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
}

// 时间格式化
export const getTimer = (stringTime) => {
  var minute = 1000 * 60
  var hour = minute * 60
  var day = hour * 24
  var time1 = new Date().getTime() //当前的时间戳
  var time2 = new Date(stringTime).getTime() //指定时间的时间戳
  var time = time1 - time2

  var result = ''
  if (time < 0) {
    result = ''
  } else if (time / day >= 3) {
    const time2ToDate = new Date(time2)
    const nowTime = new Date()
    const time2Year = time2ToDate.getFullYear()
    if (time2Year != nowTime.getFullYear()) {
      result = time2Year + '-'
    }
    result += `${time2ToDate.getMonth() + 1}-${time2ToDate.getDate()}`
  } else if (time / day >= 2 && time / day < 3) {
    result = '前天'
  } else if (time / day >= 1 && time / day < 2) {
    result = '昨天'
  } else if (time / hour >= 1) {
    result = parseInt(time / hour) + '小时前'
  } else if (time / minute >= 1) {
    result = parseInt(time / minute) + '分钟前'
  } else {
    result = '刚刚'
  }
  return result
}
